"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var FormControl_1 = require("@material-ui/core/FormControl");
var FieldCoreBase_1 = require("@react-form-fields/core/components/FieldCoreBase");
var ValidationContextRegister_1 = require("@react-form-fields/core/components/ValidationContextRegister");
var React = require("react");
var react_select_1 = require("react-select");
var withStyles_1 = require("../../decorators/withStyles");
var components_1 = require("./components");
var styles_1 = require("./styles");
var FieldAutocomplete = /** @class */ (function (_super) {
    tslib_1.__extends(FieldAutocomplete, _super);
    function FieldAutocomplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.styles = {
            input: function (base) { return (tslib_1.__assign({}, base, { color: _this.props.theme.palette.text.primary, '& input': { font: 'inherit', } })); },
        };
        _this.onChange = function (value) {
            _this.setState({ showError: true });
            _this.props.onChange(Array.isArray(value) ? value.map(function (o) { return o.value; }) : value.value);
        };
        return _this;
    }
    Object.defineProperty(FieldAutocomplete.prototype, "value", {
        get: function () {
            var value = this.props.value;
            return Array.isArray(value) ? this.props.options.filter(function (o) { return value.some(function (v) { return o.value == v; }); }) : (value || {}).value;
        },
        enumerable: true,
        configurable: true
    });
    FieldAutocomplete.prototype.render = function () {
        var _a = this.props, classes = _a.classes, theme = _a.theme, options = _a.options, value = _a.value, label = _a.label, onChange = _a.onChange, helperText = _a.helperText, placeholder = _a.placeholder, TextFieldProps = _a.TextFieldProps, extraProps = tslib_1.__rest(_a, ["classes", "theme", "options", "value", "label", "onChange", "helperText", "placeholder", "TextFieldProps"]);
        return (React.createElement("div", { className: classes.root },
            React.createElement(ValidationContextRegister_1.default, { field: this }),
            React.createElement(FormControl_1.default, { margin: extraProps.margin || 'normal', fullWidth: true, error: !!this.errorMessage, variant: extraProps.variant },
                React.createElement(react_select_1.default, tslib_1.__assign({ classes: classes, styles: this.styles }, extraProps, { textFieldProps: tslib_1.__assign({ label: label, InputLabelProps: { shrink: true } }, (TextFieldProps || {}), { error: !!this.errorMessage, helperText: this.errorMessage || helperText }), options: options, components: components_1.default, value: this.value, onChange: this.onChange, placeholder: placeholder })))));
    };
    FieldAutocomplete = tslib_1.__decorate([
        withStyles_1.WithStyles(styles_1.default, { withTheme: true })
    ], FieldAutocomplete);
    return FieldAutocomplete;
}(FieldCoreBase_1.default));
exports.default = FieldAutocomplete;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-form-fields/material-ui/components/Autocomplete/index.js
// module id = 415
// module chunks = 58